import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zNote, zObjectId } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  noteIds: z.array(zObjectId()).min(1, "Array must have at least one note ID"),
  sharedWith: z.array(zObjectId()).min(1, "Array must have at least one user ID"),
});

const responseSchema = z.array(zNote);

export default {
  method: HttpMethodEnum.PUT,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
